import React, {Component} from "react";
import {Modal} from "antd";
import { Document, Page, pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class PreviewLetter extends Component {
  state = {
    pageNumber: null
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({pageNumber: numPages});
  }

  render() {
    const { handleCancel, visible, file } = this.props;
    const { pageNumber } = this.state;
    return (
      <Modal
        title="Cover Letter Preview"
        visible={visible}
        onCancel={() => handleCancel()}
        footer={[
          <button key="cancel" className="btn btn-warning" onClick={() => handleCancel()}>Ok</button>,
        ]}
      >
        <Document
          file={file}
          onLoadSuccess={this.onDocumentLoadSuccess}
        >
          {
            Array.from(
              new Array(pageNumber),
              (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                />
              ),
            )
          }
        </Document>
      </Modal>
    );
  }
}

export default PreviewLetter;